/* 新品优先权 */
export class NewProductPriority {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.startTime = form.startTime;
      this.imageUrl = form.imageUrl;
      this.linked = form.linked;
    } else {
      this.clear();
    }
  }

  clear() {
    this.startTime = null;
    this.imageUrl = "";
    this.linked = "";
  }
}

/* 限量包装券 */
export class LimitedPackaging {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.adminStatus = form.adminStatus;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.cycle = 2; // 循环周期（0:不循环 1:按周  2:按天）
      // this.weekStart = form.weekStart;
      // this.weekEnd = form.weekEnd;
      this.startHour = form.startHour;
      this.endHour = form.endHour;
      // this.advanceBookingDays = form.advanceBookingDays || 0;
      this.imageUrl = form.imageUrl;
      this.productName = form.productName;
      this.productDescription = form.productDescription;
      this.productImages = form.productImages;
    } else {
      this.clear();
    }
  }

  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.cycle = 2;
    // this.weekStart = null;
    // this.weekEnd = null;
    this.startHour = "";
    this.endHour = "";
    // this.advanceBookingDays = 0;
    this.imageUrl = '';
    this.productName = '';
    this.productDescription = '';
    this.productImages = [];
  }
}

/* 免费洗鞋券 */
export class FreeShoeCleaningCoupon {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.adminStatus = form.adminStatus;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.cycle = 2; // 循环周期（0:不循环 1:按周 2:按天）
      // this.weekStart = form.weekStart;
      // this.weekEnd = form.weekEnd;
      this.startHour = form.startHour;
      this.endHour = form.endHour;
      // this.advanceBookingDays = form.advanceBookingDays || 0;
      this.imageUrl = form.imageUrl;
    } else {
      this.clear();
    }
  }
  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.cycle = 2;
    // this.weekStart = null;
    // this.weekEnd = null;
    this.startHour = "";
    this.endHour = "";
    // this.advanceBookingDays = 0;
    this.imageUrl = '';
  }
}

/* 运动体验券 */
export class SportsExperienceVoucher {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.adminStatus = form.adminStatus;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.cycle = 2; // 循环周期（0:不循环 1:按周 2:按天）
      // this.weekStart = form.weekStart;
      // this.weekEnd = form.weekEnd;
      this.startHour = form.startHour;
      this.endHour = form.endHour;
      // this.advanceBookingDays = form.advanceBookingDays || 0;
      this.imageUrl = form.imageUrl;
    } else {
      this.clear();
    }
  }
  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.cycle = 2;
    // this.weekStart = null;
    // this.weekEnd = null;
    this.startHour = "";
    this.endHour = "";
    // this.advanceBookingDays = 0;
    this.imageUrl = '';
  }
}

/* 活动专属优惠 */
export class ExclusivePreferential {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.startTime = form.startTime;
      this.imageUrl = form.imageUrl;
      this.eventType = form.eventType; // 活动类型 0-优惠券活动 1-商品活动
      this.level = form.level;
      this.activityType = form.activityType; // 活动渠道 1：线上 2：线下 3：线上线下
      this.linked = form.linked; // 链接地址/对应券需要兑换商品的id
      this.coupon = form.coupon;
      this.headImage = form.headImage;
    } else {
      this.clear();
    }
  }

  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.startTime = null;
    this.imageUrl = "";
    this.eventType = 0; // 活动类型 0-优惠券活动 1-商品活动
    this.level = 2;
    this.activityType = 1; // 活动渠道 1：线上 2：线下 3：线上线下
    this.linked = ""; // 链接地址/对应券需要兑换商品的id
    this.coupon = [
      {
        level: 2,
        fpMember: {
          couponIds: [],
        },
        nonFpMember: {
          couponIds: [],
        },
      },
      {
        level: 4,
        fpMember: {
          couponIds: [],
        },
        nonFpMember: {
          couponIds: [],
        },
      },
    ];
    this.headImage = '';
  }
}

/* 促销优先权 */
export class PromotionPriority {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.startTime = form.startTime;
      this.imageUrl = form.imageUrl;
      this.activityType = form.activityType; // 活动渠道 1：线上 2：线下 3：线上线下
      this.linked = form.linked; // 链接地址/对应券需要兑换商品的id
      this.storeSaleEventAddressVOS = form.storeSaleEventAddressVOS?.length ? form.storeSaleEventAddressVOS : [];
    } else {
      this.clear();
    }
  }

  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.startTime = null;
    this.imageUrl = "";
    this.activityType = 1; // 活动渠道 1：线上 2：线下 3：线上线下
    this.linked = ""; // 链接地址/对应券需要兑换商品的id
    this.storeSaleEventAddressVOS = [];
  }
}
/* 品牌活动邀请 */
export class BrandEventInvitation {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.imageUrl = form.imageUrl;
      this.offlineTime = form.offlineTime;
      this.linked = form.linked; // 链接地址/对应券需要兑换商品的id
      this.landingPageImageUrl = form.landingPageImageUrl;
    } else {
      this.clear();
    }
  }

  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.imageUrl = "";
    this.offlineTime = null;
    this.linked = ""; // 链接地址/对应券需要兑换商品的id
    this.landingPageImageUrl = '';
  }
}
/* 周年纪念礼 */
export class AnniversaryCeremony {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.adminStatus = form.adminStatus;
      this.titles = form.titles;
      this.subtitles = form.subtitles;
      this.imageUrl = form.imageUrl;
      this.productName = form.productName;
      this.productDescription = form.productDescription;
      this.productImages = form.productImages;
      this.startTime = form.startTime;
      this.endTime = form.endTime;
    } else {
      this.clear();
    }
  }

  clear() {
    this.titles = ['', ''];
    this.subtitles = ['', ''];
    this.imageUrl = '';
    this.productName = '';
    this.productDescription = '';
    this.productImages = [];
  }
}
export const BenefitsRoutes = {
  one: '/member/benefits',
  two: '/member/limitedPackaging/edit',
  three: '/member/freeShoeCleaningCoupon/edit',
  four: '/member/sportsExperienceVoucher/edit',
  five: '/member/activityExclusivePreferential/index',
  six: '/member/promotionPriority/index',
  seven: '/member/brandEventInvitation/index',
  eight: '/member/anniversaryCeremony/edit',
};
